<template>
  <div class="messages-control" style="max-width: 330px; overflow: hidden; z-index: 120000">
    <transition-group name="list" mode="out-in" style="position: relative">
      <v-alert v-for="message in messages" :key="message.id" :type="message.message_class" @click="message.resolve" style="width: 100%; max-width: 330px; cursor: pointer; white-space: pre-wrap; font-size: .8rem; user-select: none">{{ message.text }}</v-alert>
    </transition-group>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['messages'])
  }
}
</script>

<style>
.messages-control {
  display: flex;
  flex-direction: column-reverse;
  position: fixed;
  width: 300px;
  right: 0;
  top: auto;
  /* min-height: 100px; */
  bottom: 0px;
}

.list-move {
  transition: all 0.5s ease;
}
.list-enter-active {
  transition: all 0.5s ease;
  opacity: 0;
  transform: translateX(30px);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0px);
}

.list-leave-active {
  position: absolute;
  transition: all 0.5s ease;
  opacity: 1;
  transform: translateX(0px);
}

.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

</style>